import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

export default function PageLayout({ children }) {
  return (
    <div
      className="min-h-screen flex flex-col relative overflow-hidden"
      style={{ backgroundColor: '#accbff' }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat -z-10"
        style={{ backgroundImage: 'url(/bg1.jpeg)', opacity: 0.35 }}
      />
      <Navbar />
      <main className="flex-1 pt-40 md:pt-44">
        {children}
      </main>
      <Footer />
    </div>
  );
}
